module.exports = __webpack_public_path__ + "static/media/rating-3.b55869d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/rating-3.svg
// module id = 1092
// module chunks = 0